import {
  ODataHeader,
  ODataString,
  ODataDateTime,
  ODataInteger,
  ODataEnum,
} from "pbas-vue-components";
import { i18n } from "@/plugins/i18n";
function getHeaders(enums) {
  const headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "headers.claims_payments.BatchNumber",
      type: new ODataInteger("BatchNumber", {
        getString: (item) => {
          let batchNumber = item.BatchNumber.toString();
          for (let i = batchNumber.length; i < 4; i++) {
            batchNumber = "0" + batchNumber;
          }
          return batchNumber;
        },
      }),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_payments.PaymentMethod",
      type: new ODataEnum("PaymentMethod", {
        getString: (item) => {
          return i18n.t("enums." + item.PaymentMethod);
        },
        dropdownItems: enums.PaymentMethod,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_payments.IssuedBy",
      type: new ODataString("IssuedBy"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_payments.IssuedAt",
      type: new ODataDateTime("IssuedAt"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "FileId",
      type: new ODataString("FileId"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("FileName"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      sortable: false,
      version: 1,
    }),
    new ODataHeader({
      type: new ODataString("ChequeTemplateFileId"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ChequeTemplateFileName"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      sortable: false,
    }),
  ];
  return headers;
}

export default getHeaders;
